import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import appConfig from '@jobmatchme/library-utils/es/appConfig';
var ENTRY_SURFACE = 'jobs_web';
var ENTRY_PATH_PATTERN = /^\/(?:de|at|pl|en)\/jobs\/(?:service-gastro|fahrer|logistik|disponenten|all)\/suche(?:\/.*)?$/;
var readAdsConsent = function readAdsConsent() {
  var _Cookiebot;
  var consent = (_Cookiebot = window.Cookiebot) === null || _Cookiebot === void 0 ? void 0 : _Cookiebot.consent;
  if (!consent) {
    return undefined;
  }
  if (typeof consent.marketing === 'boolean') {
    return consent.marketing;
  }
  return undefined;
};
var readConsentSnapshot = function readConsentSnapshot() {
  var _Cookiebot2;
  var consent = (_Cookiebot2 = window.Cookiebot) === null || _Cookiebot2 === void 0 ? void 0 : _Cookiebot2.consent;
  var adsConsent = readAdsConsent();
  if (adsConsent === undefined) {
    return undefined;
  }
  return {
    usage: typeof (consent === null || consent === void 0 ? void 0 : consent.statistics) === 'boolean' ? consent.statistics : false,
    marketing: adsConsent,
    ad_storage: adsConsent,
    ad_user_data: adsConsent,
    ad_personalization: adsConsent,
    source: 'cookiebot',
    version: 1
  };
};
var hasRegisteredConsentUpdates = false;
var lastConsentUpdateKey;
export var shouldCreateEntry = function shouldCreateEntry() {
  var pathPattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ENTRY_PATH_PATTERN;
  var pathname = window.location.pathname;
  if (!pathPattern.test(pathname)) {
    return false;
  }
  return true;
};
export var updateCurrentEntryConsent = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _ref2,
      _ref2$consentEndpoint,
      consentEndpoint,
      _ref2$pathPattern,
      pathPattern,
      adsConsent,
      consent,
      updateKey,
      response,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref2 = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, _ref2$consentEndpoint = _ref2.consentEndpoint, consentEndpoint = _ref2$consentEndpoint === void 0 ? "".concat(appConfig.routes.comApi, "/tracking/entries/current/consent") : _ref2$consentEndpoint, _ref2$pathPattern = _ref2.pathPattern, pathPattern = _ref2$pathPattern === void 0 ? ENTRY_PATH_PATTERN : _ref2$pathPattern;
            _context.prev = 1;
            if (shouldCreateEntry(pathPattern)) {
              _context.next = 4;
              break;
            }
            return _context.abrupt("return");
          case 4:
            adsConsent = readAdsConsent();
            consent = readConsentSnapshot();
            if (consent) {
              _context.next = 8;
              break;
            }
            return _context.abrupt("return");
          case 8:
            updateKey = "".concat(consentEndpoint, ":").concat(JSON.stringify(consent));
            if (!(lastConsentUpdateKey === updateKey)) {
              _context.next = 11;
              break;
            }
            return _context.abrupt("return");
          case 11:
            _context.next = 13;
            return fetch(consentEndpoint, {
              method: 'POST',
              credentials: 'include',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify({
                adsConsent: adsConsent,
                consent: consent
              })
            });
          case 13:
            response = _context.sent;
            if (response.ok) {
              lastConsentUpdateKey = updateKey;
            }
            _context.next = 20;
            break;
          case 17:
            _context.prev = 17;
            _context.t0 = _context["catch"](1);
            console.error('entry consent update failed', _context.t0);
          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 17]]);
  }));
  return function updateCurrentEntryConsent() {
    return _ref.apply(this, arguments);
  };
}();
var registerConsentUpdates = function registerConsentUpdates() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (hasRegisteredConsentUpdates) {
    return;
  }
  hasRegisteredConsentUpdates = true;
  updateCurrentEntryConsent(options);
  ['CookiebotOnConsentReady', 'CookiebotOnAccept', 'CookiebotOnDecline'].forEach(function (eventName) {
    window.addEventListener(eventName, function () {
      updateCurrentEntryConsent(options);
    });
  });
};
export var createEntry = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var _ref4,
      _ref4$endpoint,
      endpoint,
      _ref4$surface,
      surface,
      _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _ref4 = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {}, _ref4$endpoint = _ref4.endpoint, endpoint = _ref4$endpoint === void 0 ? "".concat(appConfig.routes.comApi, "/tracking/entries/bootstrap") : _ref4$endpoint, _ref4$surface = _ref4.surface, surface = _ref4$surface === void 0 ? ENTRY_SURFACE : _ref4$surface;
            _context2.prev = 1;
            if (shouldCreateEntry()) {
              _context2.next = 4;
              break;
            }
            return _context2.abrupt("return");
          case 4:
            _context2.next = 6;
            return fetch(endpoint, {
              method: 'POST',
              credentials: 'include',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify({
                surface: surface,
                context: {
                  href: window.location.href,
                  pathname: window.location.pathname,
                  search: window.location.search,
                  referrer: document.referrer || undefined
                },
                adsConsent: readAdsConsent(),
                consent: readConsentSnapshot()
              })
            });
          case 6:
            _context2.next = 11;
            break;
          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](1);
            console.error('entry tracking failed', _context2.t0);
          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 8]]);
  }));
  return function createEntry() {
    return _ref3.apply(this, arguments);
  };
}();
export var bootstrapEntryTracking = function bootstrapEntryTracking() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  registerConsentUpdates(options);
  return createEntry(options).then(function () {
    return updateCurrentEntryConsent(options);
  });
};